import { put } from "redux-saga/effects";

import { davInstance } from "axios-config";
import * as actions from "./actions";

export function* fetchActivityLogsStart(action) {
  try {
    const response = yield davInstance.get("/audit/get", {
      params: {
        startDate: action.startDate,
        endDate: action.endDate
      }
    });

    if (response.status === 200) {
      yield put(actions.fetchActivityLogsSuccess(response.data));
    } else {
      yield put(actions.fetchActivityLogsSuccess([]));
    }
  } catch (error) {
    console.log(error);
  }
}
